import React, { useState } from "react";
import NavBar from "./NavBar";
import Sidebar from "./Sidebar";
import RightSidebar from "./RightSidebar";
import { useVersionCheck } from "../hooks/useVersionCheck";
import UpdateAvailableBanner from "./common/UpdateAvailableBanner";
import { ChatManager } from "./chat/ChatManager";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { isUpdateAvailable, dismiss } = useVersionCheck();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const handleRefresh = () => {
    dismiss();
    window.location.reload();
  };

  return (
    <div className="flex h-full min-h-[calc(100vh-96px)] bg-n-2 relative xl:pl-[18.75rem]">
      <NavBar />

      {/* Mobile overlay */}
      <div className="xl:hidden">
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
      </div>

      {/* Sidebar - hidden below xl unless toggled */}
      <div className="hidden xl:block">
        <Sidebar />
      </div>
      <div
        className={`
        xl:hidden
        fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out
        ${!isSidebarOpen ? "-translate-x-full" : "translate-x-0"}
      `}
      >
        <Sidebar
          isMobile={true}
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
      </div>

      {/* Main content */}
      <main className="flex-1 overflow-auto pt-18">
        {/* Mobile hamburger button */}
        <div className="xl:hidden">
          <div className="sticky top-0 z-30 bg-black border-b border-white px-4 py-3">
            <button
              onClick={toggleSidebar}
              className="p-2 text-white hover:text-gray-300 hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-white"
              aria-label="Toggle navigation menu"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
        <UpdateAvailableBanner isUpdateAvailable={isUpdateAvailable} onRefresh={handleRefresh} />
        {children}
      </main>

      {/* Right sidebar - hidden on mobile and tablet */}
      {/* <div className="hidden xl:block">
        <RightSidebar />
      </div> */}

      <ChatManager />
    </div>
  );
};

export default Layout;
